var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-list",
    [
      _c(
        "v-list-item",
        [
          _c("SoliAvatarBtn", {
            attrs: {
              title: "I'll have the usual",
              outlined: "",
              icon: "event_repeat",
              blue: "",
              subtitleBottom: "Same teacher, instrument...",
            },
            on: {
              click: function ($event) {
                return _vm.$emit("input", false)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-list-item",
        [
          _c("SoliAvatarBtn", {
            attrs: {
              title: "Try something new",
              outlined: "",
              icon: "rocket_launch",
              blue: "",
              subtitleBottom: "Branch out. Blast off.",
            },
            on: {
              click: function ($event) {
                return _vm.$emit("input", true)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }